import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import RobitoLogo from "../components/RobitoLogo";
import "../App.css";
import { apiPostPublic} from "../utils/api";

export default function ResetPasswordPage() {
  const { email, token } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [validToken, setValidToken] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState("");

  // Validate token
  useEffect(() => {
    const validateToken = async () => {
      try {
        const response = await apiPostPublic("check_reset_password_token.php", {
            email: email, token: token
        });

        if (response.result === 1) {
          setValidToken(true);
        } else {
          navigate("/login");
        }
      } catch (error) {
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    validateToken();
  }, [email, token, navigate]);

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setError("");

    if (password.length < 6) {
      setError("Password must be at least 6 characters long.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setUpdating(true);
    try {
      const response = await apiPostPublic("reset_password.php", {
        email: email, token: token, password: password
      });

      if (response.result === 1) {
        alert("Password has been reset successfully.");
        navigate("/login");
      } else {
        setError(response.message || "Failed to reset password.");
      }
    } catch (error) {
      setError("Something went wrong. Please try again later.");
    } finally {
      setUpdating(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <div className="loading-spinner"></div>
        <p>Validating token...</p>
      </div>
    );
  }

  if (!validToken) return null; // Prevent rendering if token is invalid

  return (
    <div className="page-wrapper">
      <div className="auth-card">
        <RobitoLogo />
        <h2 className="form-title">Reset Your Password</h2>
        <form onSubmit={handlePasswordReset} className="form-container">
          <input
            type="password"
            placeholder="New Password"
            className="input-field"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Confirm New Password"
            className="input-field"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          {error && <p className="error-message">{error}</p>}
          <button type="submit" className="primary-button" disabled={updating}>
            {updating ? "Updating..." : "Update Password"}
          </button>
        </form>
        <div className="copyright">© Robito.Ai 2025</div>
      </div>
    </div>
  );
}
